import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";

function ConvertToSearchModal({ onClose, roleData, token, refresh}) {
  const REACT_APP_API_BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const CURRENCY_API_KEY = process.env.REACT_APP_CURRENCY_API_KEY;
  const navigate = useNavigate();
  const [conversionRate, setConversionRate] = useState(1);
  const [form, setForm] = useState({
    reference: "",
    name: "",
    rolelevel_id: 4,
    band: "",
    expected_compensation: "",
    expected_approx_fee: "",
    currency_id: "",
    conversion_rate: "",
    active: true,
    dossier: false,
    position_number: 1,
    move_candidates: true,
    keep_status: true,
  });

  const [masterData, setMasterData] = useState({ rolelevel: [], currency: [] });
  const [currencies, setCurrencies] = useState([]);

  const fetchMasterData = async () => {
    const response = await axios.get(
        `${REACT_APP_API_BASE_URL}/roles/basic_add_role_form_details`,
        {
            headers: {
                Authorization: `Bearer ${token}`,
            },
        }
    );
    setMasterData(response.data);
      setForm((prev) => ({
            ...prev,
            reference: response.data.next_reference?.[0]?.next_reference || "",
        }));
   };
    useEffect(() => {
    fetchMasterData();
    }, []);

    useEffect(() => {

        if (!roleData || masterData.currency.length === 0) return;
        const currency = masterData.currency.find(
            (c) => c.id === Number(roleData.currency_id)
        );

        if (currency) {
            getConversation(currency.name);
        }
        setForm((prev) => ({
            ...prev,
            name: roleData.name,
            rolelevel_id: roleData.rolelevel_id || 4,
            band: roleData.band,
            expected_compensation: roleData.expected_compensation,
            expected_approx_fee: roleData.expected_approx_fee,
            currency_id: Number(roleData.currency_id),
            conversion_rate: roleData.conversion_rate,
            active: roleData.active === "1",
            dossier: roleData.dossier === "1",
            position_number: roleData.position_number,
            move_candidates: true,
            keep_status: true,
        }));

    }, [roleData, masterData.currency]);


  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    setForm((prev) => ({
      ...prev,
      [name]:
        type === "checkbox"
          ? checked
          : value,
    }));
  };

  const handleSubmit = async () => {
    const requiredFields = {
        name: "Role Name",
        rolelevel_id: "Role Level",
        expected_compensation: "Expected Compensation",
        expected_approx_fee: "Expected Approx Fee",
        currency_id: "Currency",
        conversion_rate: "Fees Conversion Rate",
        position_number: "No. of Position",
    };
    for (const [key, label] of Object.entries(requiredFields)) {
        if (
        form[key] === "" ||
        form[key] === null ||
        form[key] === undefined
        ) {
        alert(`${label} is required.`);
        return;
        }
    }
    try {
        const { data } = await axios.post(
            `${REACT_APP_API_BASE_URL}/roles/convert_to_search/${roleData.id}`,
            form,
            {
                headers: { Authorization: `Bearer ${token}`},
            }
            );

      alert("Role converted successfully");

      refresh();
      onClose();
      navigate(`/role/view/${data.role_id}`);
    } catch (err) {
      console.log(err);
      alert("Conversion failed");
    }
  };

  const getConversation = async (currencyName) => {
    try {
        const response = await axios.get(
        `https://api.currconv.com/api/v7/convert?q=${currencyName}_INR&compact=ultra&apiKey=${CURRENCY_API_KEY}`
        );

        const rate = response.data;
        const [, value] = Object.entries(rate)[0];

        setConversionRate(value ?? 1);

        setForm((prev) => ({
        ...prev,
        conversion_rate: value ?? 1,
        }));
    } catch (error) {
        console.log(error);
    }
  };

  const handleCurrencyChange = (e) => {
    const selectedCurrencyId = parseInt(e.target.value);

    setForm((prev) => ({
        ...prev,
        currency_id: selectedCurrencyId,
    }));

    const currency = masterData.currency.find(
        (c) => c.id === selectedCurrencyId
    )?.name;

    if (currency) {
        getConversation(currency);
    }
  };
  return (
    <>
      <div className="modal fade show d-block">
        <div className="modal-dialog modal-lg">
          <div className="modal-content">
            <div className="modal-header">
              <h5>Convert Talent Scan to Search</h5>

              <button
                className="btn-close"
                onClick={onClose}
              />
            </div>
            <input type="hidden" name="reference" value={form.reference}/>
            <div className="modal-body">
            <div className="row mb-3">
                <div className="col-md-6">
                    <label>Role Name *</label>
                    <input className="form-control" name="name" value={form.name} onChange={handleChange} />
                </div>
                <div className="col-md-6">
                <label>Role Level *</label>
                <select className="form-select" name="rolelevel_id" value={form.rolelevel_id} onChange={handleChange}>
                    {masterData.rolelevel.map(level=>(
                        <option key={level.id} value={level.id}>{level.name}</option>
                    ))}
                </select>
                </div>
            </div>
            <div className="row mb-3">
            <div className="col-md-6">
                <label>Band / Title</label>
                <input className="form-control" name="band" value={form.band} onChange={handleChange} />
            </div>
            <div className="col-md-6">
                <label>No. of Position</label>
                <input type="number" className="form-control" name="position_number" value={form.position_number} onChange={handleChange} />
            </div>
            </div>

            <div className="row mb-3">
            <div className="col-md-6">
                <label>Expected Compensation *</label>
                <input type="number" className="form-control" name="expected_compensation" value={form.expected_compensation} onChange={handleChange} />
            </div>
            <div className="col-md-6">
                <label>Expected Approx Fee *</label>
                <input type="number" className="form-control" name="expected_approx_fee" value={form.expected_approx_fee} onChange={handleChange} />
            </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-6">
                    <label>Currency</label>
                    <select className="form-select" name="currency_id" value={form.currency_id} onChange={handleCurrencyChange}>
                    {masterData.currency.map(currency=>(
                    <option key={currency.id} value={currency.id}>
                        {currency.symbol} - {currency.name}
                    </option>
                    ))}
                    </select>
                </div>
                <div className="col-md-6">
                    <label>Fees Conversion Rate</label>
                    <input className="form-control" name="conversion_rate" value={conversionRate ?? form.conversion_rate ?? 1} onChange={handleChange}/>
                </div>
            </div>

            <div className="row mb-3">
                <div className="col-md-3">
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="active" checked={form.active} onChange={handleChange} />
                    <label className="form-check-label">Role Activate</label>
                </div>
                </div>

                <div className="col-md-3">
                <div className="form-check form-switch">
                    <input className="form-check-input" type="checkbox" name="dossier" checked={form.dossier} onChange={handleChange} />
                    <label className="form-check-label">Dossier</label>
                </div>
                </div>

                <div className="col-md-6">
                    <div className="form-check mb-2">
                    <input
                        type="checkbox"
                        className="form-check-input"
                        name="move_candidates"
                        checked={form.move_candidates}
                        onChange={handleChange}
                    />
                    <label className="form-check-label">
                        Move Candidate Pipeline
                    </label>
                    </div>

                    {form.move_candidates && (
                    <div className="form-check mb-3">
                        <input
                        type="checkbox"
                        className="form-check-input"
                        name="keep_status"
                        checked={form.keep_status}
                        onChange={handleChange}
                        />

                        <label className="form-check-label">
                        Keep Candidate Status
                        </label>
                    </div>
                    )}
                </div>
            </div>
            </div>

            <div className="modal-footer">
              <button className="btn btn-secondary me-2" onClick={onClose}>
                Cancel
              </button>

              <button className="btn btn-primary" onClick={handleSubmit}>
                Convert
              </button>
            </div>
          </div>
        </div>
      </div>

      <div className="modal-backdrop fade show"></div>
    </>
  );
}

export default ConvertToSearchModal;